import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

let y = '10rem';
let toggleActions = 'play none reverse none';

let breakpoint = 1024;
let scrub = (window.innerWidth < breakpoint) ? true : true;

gsap.from(".gasp-tout-trigger-1", {
    scrollTrigger: {
        toggleActions: toggleActions,
        trigger: ".gasp-tout-trigger-1",
        start: 'top bottom',
        end: 'top +=80%',
        markers: false,
        scrub: true,
    },
    y: y,
});

gsap.from(".gasp-tout-trigger-2", {
    scrollTrigger: {
        toggleActions: toggleActions,
        trigger: ".gasp-tout-trigger-2",
        start: 'top bottom',
        end: 'top +=80%',
        markers: false,
        scrub: scrub,
    },
    y: y,
});

gsap.from(".gasp-tout-trigger-3", {
    scrollTrigger: {
        toggleActions: toggleActions,
        trigger: ".gasp-tout-trigger-3",
        start: 'top bottom',
        end: 'top +=80%',
        markers: false,
        scrub: true,
    },
    y: y,
});

gsap.from(".gasp-tout-trigger-4", {
    scrollTrigger: {
        toggleActions: toggleActions,
        trigger: ".gasp-tout-trigger-4",
        start: 'top bottom',
        end: 'top +=80%',
        markers: false,
        scrub: scrub,
    },
    y: y,
});